<template>
  <div class="alumno-upload-container">
    <h3 class="title">Ingreso Masivo de Alumnos</h3>

    <div class="upload-section">
      <label class="file-label">
        <span>Seleccionar archivo Excel (.xlsx, .xls)</span>
        <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" class="file-input" />
      </label>
    </div>

    <div v-if="excelData.length" class="progress-section">
      <div class="progress-info">
        <span>Progreso: {{ processedCount }} / {{ excelData.length }}</span>
        <span>{{ currentStatus }}</span>
      </div>
      <progress :value="processedCount" :max="excelData.length"></progress>
      <button 
        class="action-button" 
        @click="procesarAlumnos" 
        :disabled="isProcessing"
      >
        {{ isProcessing ? 'Procesando...' : 'Iniciar Proceso' }}
      </button>
      
      <div v-if="errores.length" class="error-actions">
        <button class="error-button" @click="descargarErrores">
          Descargar Errores ({{ errores.length }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import UsuarioService from '@/services/UsuarioService';

export default {
  data() {
    return {
      excelData: [],
      isProcessing: false,
      processedCount: 0,
      currentStatus: '',
      errores: [],
      usuarioId: 1,
      colegios: {
        "NO APLICA": { id_colegio: 0, direccion_calle: "", direccion_numero: 0 },
        "MINEDUC DEMO": { id_colegio: 1, direccion_calle: "EJERCITO", direccion_numero: 557 },
        "COLEGIO ACONCAGUA": { id_colegio: 2, direccion_calle: "Camino Troncal Antiguo", direccion_numero: 1940 },
        "COLEGIO SAN NICOLÁS VILLA ALEMANA": { id_colegio: 3, direccion_calle: "Santa Sarah", direccion_numero: 1720 },
        "COLEGIO SAN NICOLÁS CANAL CHACAO": { id_colegio: 4, direccion_calle: "Los Lunes", direccion_numero: 373 },
        "COLEGIO SAN NICOLÁS EL OLIVAR": { id_colegio: 5, direccion_calle: "Tamarugal", direccion_numero: 575 }
      },
      regiones: [
        { Id: 6, Glosa: 'Valparaíso' }
      ],
      comunas: [
        { Id: 45, Glosa: 'Valparaíso' },
        // ... (resto de comunas igual que antes)
      ]
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Resetear estado
        this.excelData = jsonData.slice(1);
        this.processedCount = 0;
        this.errores = [];
        this.currentStatus = '';
      };
      reader.readAsArrayBuffer(file);
    },

    getIdComunaPorColegio(colegioGlosa) {
      const comunaPorColegio = {
        "NO APLICA": "Villa Alemana",
        "MINEDUC DEMO": "Villa Alemana",
        "COLEGIO ACONCAGUA": "Quilpué",
        "Colegio San Nicolás Villa Alemana": "Villa Alemana",
        "Colegio San Nicolás Canal Chacao": "Quilpué",
        "COLEGIO SAN NICOLÁS EL OLIVAR": "Viña del Mar"
      };
      const comunaGlosa = comunaPorColegio[colegioGlosa] || "Villa Alemana";
      const comuna = this.comunas.find(c => c.Glosa === comunaGlosa);
      return comuna ? comuna.Id : 52;
    },

    async procesarAlumnos() {
      if (this.isProcessing || !this.excelData.length) return;
      
      this.isProcessing = true;
      this.processedCount = 0;
      this.errores = [];
      
      try {
        for (let i = 0; i < this.excelData.length; i++) {
          const rowData = this.excelData[i];
          this.currentStatus = `Procesando fila ${i + 1}...`;
          
          try {
            const result = await this.procesarFila(rowData);
            if (result.error) {
              this.errores.push([...rowData, result.error]);
            }
          } catch (error) {
            this.errores.push([...rowData, error.message || "Error desconocido"]);
          }
          
          this.processedCount++;
          await new Promise(resolve => setTimeout(resolve, 100)); // Pequeña pausa para evitar saturación
        }
        
        this.currentStatus = `Proceso completado. ${this.excelData.length - this.errores.length} éxitos, ${this.errores.length} errores.`;
      } catch (error) {
        console.error("Error inesperado:", error);
        this.currentStatus = "Error inesperado en el proceso";
      } finally {
        this.isProcessing = false;
      }
    },
    
    async procesarFila(rowData) {
      const colegioGlosa = rowData[0] ? rowData[0].toString().toUpperCase() : '';
      const colegio = this.colegios[colegioGlosa];
      if (!colegio) {
        throw new Error(`Colegio no reconocido: ${rowData[0]}`);
      }

      const idComuna = this.getIdComunaPorColegio(colegioGlosa);

        alert(rowData[1]);
      const payload = {
        pass_: Array.from(new TextEncoder().encode("12345678")),
        PassphraseEnteredByUser: "hola test estudyoo 2021 ##",
        id_usuario: this.usuarioId,
        id_contrato: 0,
        email: rowData[8],
        nombre_usuario: `${rowData[6]}.${rowData[4]}`,
        nombre: rowData[6],
        apellido_paterno: rowData[4],
        apellido_materno: rowData[5],
        celular: "0",
        identificador_rut: rowData[3],
        sexo: rowData[7] ? rowData[7].charAt(0) : 'F',
        direccion_calle: colegio.direccion_calle,
        direccion_numero: colegio.direccion_numero,
        id_colegio: colegio.id_colegio,
        id_region: this.regiones[0].Id,
        id_comuna: idComuna,
        cursos: [rowData[1]],
        curso_casa: rowData[2] ? rowData[2].toString().charAt(0) : ''
      };

      if (!payload.email || !payload.nombre || !payload.identificador_rut) {
        throw new Error("Faltan campos obligatorios (correo, nombre o RUT)");
      }

      const response = await UsuarioService.crearUsuarioIndividual(payload);
      if (response.data.Mensaje !== "Usuario procesado con éxito") {
        throw new Error(response.data.Mensaje || "Error desconocido en la respuesta");
      }
      
      return { success: true };
    },

    descargarErrores() {
      if (!this.errores.length) return;
      
      const headers = ["Colegio", "Curso", "Curso Casa", "RUT", "Apellido Paterno", 
                      "Apellido Materno", "Nombre", "Sexo", "Email", "Error"];
      const data = [headers, ...this.errores];
      
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Errores");
      
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement("a");
      link.href = url;
      link.download = "Errores_Alumnos.xlsx";
      link.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.alumno-upload-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

.title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.upload-section {
  margin-bottom: 30px;
  text-align: center;
}

.file-label {
  display: inline-block;
  padding: 12px 24px;
  background-color: #4285f4;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-weight: bold;
}

.file-label:hover {
  background-color: #3367d6;
}

.file-input {
  display: none;
}

.progress-section {
  margin-top: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
}

progress {
  width: 100%;
  height: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}

progress::-webkit-progress-bar {
  background-color: #e9ecef;
  border-radius: 5px;
}

progress::-webkit-progress-value {
  background-color: #28a745;
  border-radius: 5px;
}

.action-button {
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.action-button:hover {
  background-color: #218838;
}

.action-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.error-actions {
  margin-top: 20px;
}

.error-button {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.error-button:hover {
  background-color: #c82333;
}
</style>